import { get } from "./http";

export const getCouponDiscount = async (coupon, currentCartAmount) => {
  const jsonData = await get(`/ecom/coupon/${coupon}?amount=${currentCartAmount}`);
  let data;
  if (jsonData) {
    if (jsonData.error) {
      console.error("getCouponDiscount error :", jsonData);
      data = jsonData;
    } else {
      data = jsonData;
    }
  }
  return data;
};

export const checkZipCode = async (zipcode) => {
  const res = await get(`/ecom/cities/${zipcode}/`);
  return res?.status;
};
